import React, { useEffect } from 'react';
import { Outlet, Navigate } from 'react-router-dom';

import { Header } from '@features/header/Header';
import { useAuthStore } from 'src/store/auth';
import { cn } from '@utils/index';
import { LayoutProvider, useLayout } from './LayoutContext';
import { LayoutLoading } from 'src/layouts/LayoutLoading';



interface PublicLayoutProps {
  mainClassName?: string;
}

const PublicLayoutContent: React.FC<PublicLayoutProps> = ({
  mainClassName: propMainClassName,
}) => {
  const { isAuthenticated } = useAuthStore();
  const { mainClassName: contextMainClassName } = useLayout();

  useEffect(() => {}, [isAuthenticated]);

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  const finalMainClassName = propMainClassName || contextMainClassName;

  return (
    <div className="flex flex-col min-h-screen pt-5 pb-6 gap-6">
      <LayoutLoading />
      <Header />
      <main
        className={cn(
          'flex justify-between rounded-xl w-full max-w-[1920px] mx-auto px-6 min-h-[calc(100vh-156px)]',
          finalMainClassName
        )}
      >
        <div className="w-full">
          <Outlet />
        </div>
      </main>
      {/* <Footer /> */}
    </div>
  );
};

export const PublicLayout: React.FC<PublicLayoutProps> = (props) => {
  return (
    <LayoutProvider>
      <PublicLayoutContent {...props} />
    </LayoutProvider>
  );
};
